import { render } from "./CometChatGroupListItem.vue?vue&type=template&id=1272ac24&scoped=true"
import script from "./CometChatGroupListItem.vue?vue&type=script&lang=js"
export * from "./CometChatGroupListItem.vue?vue&type=script&lang=js"

import "./CometChatGroupListItem.vue?vue&type=style&index=0&id=1272ac24&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1272ac24"]])

export default __exports__